var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 140.25 78.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e2e9f2;}.cls-2{fill:#9cfffd;}.cls-3{fill:#fff;}.cls-4{fill:#2c3d60;}.cls-5{fill:#ccd5de;}.cls-6{fill:#f0faff;}.cls-7{fill:#fef3b3;}.cls-8{fill:#fffdeb;}.cls-9{fill:#b8ccf5;}.cls-10{fill:#80dfff;}.cls-11{fill:#8fb4ff;}.cls-12{fill:#bafffe;}.cls-13{fill:#8a97ff;}.cls-14{fill:#e6f4ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "assembly-line") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "assembly-line"
  }, /*#__PURE__*/React.createElement("g", {
    id: "belt"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colors-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.5,122.72H48.56A12.48,12.48,0,0,0,36.1,135.09c0,6.9,6,12.54,12.92,12.54H151.5a12.46,12.46,0,0,0,.71-24.91h-.71Z",
    transform: "translate(-29.89 -70.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadows-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.64,147.57c.44,0,.9.06,1.37.06C48.54,147.63,48.09,147.6,47.64,147.57Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.41,147.57c-.45,0-.9.06-1.37.06C151.51,147.63,152,147.61,152.41,147.57Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M151,122.82H49c-16.73,0-17.17,23.47-1.36,24.75-13.38-1.21-12.92-20.08,1.37-20.08H151c14.3,0,14.75,18.87,1.37,20.08C168.22,146.29,167.77,122.83,151,122.82Z",
    transform: "translate(-29.89 -70.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.5,147.37a1,1,0,0,1-.74-1.67,17.84,17.84,0,0,0,4.36-8.84,1,1,0,0,1,2,.35,19.84,19.84,0,0,1-4.85,9.83A1,1,0,0,1,164.5,147.37Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M30.89,136.64h0a1,1,0,0,1-1-1,19.89,19.89,0,0,1,5.17-13.08,1,1,0,0,1,1.48,1.34,17.89,17.89,0,0,0-4.65,11.76A1,1,0,0,1,30.89,136.64Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.25,140.33a1,1,0,0,1,0-2h0a1,1,0,0,1,0,2Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49,149.13a14.72,14.72,0,0,1-10.37-4.36,13.57,13.57,0,0,1-4-9.69,14,14,0,0,1,14-13.85H151.5a14,14,0,1,1,0,27.9Zm-.46-24.91a11,11,0,0,0-11,10.87,10.6,10.6,0,0,0,3.18,7.56A11.71,11.71,0,0,0,49,146.13H151.5a11,11,0,1,0,0-21.9Z",
    transform: "translate(-29.89 -70.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "rollers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 121.16,
    cy: 64.32,
    r: 5.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M66.7,130.16a5,5,0,1,1-5,5A5,5,0,0,1,66.7,130.16Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 19.12,
    cy: 64.32,
    r: 5.02
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M133.36,130.16a5,5,0,1,1-5,5A5,5,0,0,1,133.36,130.16Z",
    transform: "translate(-29.89 -70.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadows-28"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 48.13,
    cy: 134.3,
    rx: 2.28,
    ry: 1.71,
    transform: "translate(-110.76 2.51) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 65.75,
    cy: 134.3,
    rx: 2.28,
    ry: 1.71,
    transform: "translate(-105.6 14.97) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 132.54,
    cy: 134.3,
    rx: 2.28,
    ry: 1.71,
    transform: "translate(-86.03 62.2) rotate(-45)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 150.17,
    cy: 134.31,
    rx: 2.28,
    ry: 1.71,
    transform: "translate(-80.88 74.66) rotate(-45)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M49,141.7a6.52,6.52,0,1,1,6.52-6.52A6.52,6.52,0,0,1,49,141.7Zm0-10a3.52,3.52,0,1,0,3.52,3.52A3.52,3.52,0,0,0,49,131.7h0Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.69,141.7a6.52,6.52,0,1,1,6.52-6.52A6.52,6.52,0,0,1,66.69,141.7Zm0-10a3.52,3.52,0,1,0,3.52,3.52,3.52,3.52,0,0,0-3.52-3.52h0Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M151,141.7a6.52,6.52,0,1,1,6.52-6.52A6.52,6.52,0,0,1,151,141.7Zm0-10a3.52,3.52,0,1,0,3.52,3.52A3.52,3.52,0,0,0,151,131.7h0Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M133.36,141.7a6.52,6.52,0,1,1,6.52-6.52A6.52,6.52,0,0,1,133.36,141.7Zm0-10a3.52,3.52,0,1,0,3.52,3.52,3.52,3.52,0,0,0-3.52-3.52h0Z",
    transform: "translate(-29.89 -70.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "box-2-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colors-33"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "134.05 26.1 134.05 51.86 121.61 51.86 108.28 51.86 108.28 26.1 134.05 26.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadows-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M164,97H138.11v3.41h0v22.45h3.41V101.43a1.06,1.06,0,0,1,1.06-1.06H164Z",
    transform: "translate(-29.89 -70.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M163.93,124.22H138.16a1.5,1.5,0,0,1-1.5-1.5V97a1.5,1.5,0,0,1,1.5-1.5h25.77a1.5,1.5,0,0,1,1.5,1.5v25.77A1.5,1.5,0,0,1,163.93,124.22Zm-24.27-3h22.77V98.46H139.66Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.65,118.24a1,1,0,0,1-.71-1.71l14.8-14.8a1,1,0,0,1,1.41,1.41l-14.8,14.8A1,1,0,0,1,143.65,118.24Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M158.45,118.24a1,1,0,0,1-.71-.29l-14.8-14.8a1,1,0,0,1,1.41-1.41l14.8,14.8a1,1,0,0,1-.71,1.71Z",
    transform: "translate(-29.89 -70.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "box-1-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colors-34"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "41.82 26.1 41.82 51.86 18.67 51.86 16.06 51.86 16.06 26.1 41.82 26.1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadows-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M71.76,97H45.9v3.41h0v22.45h3.41V101.43a1.06,1.06,0,0,1,1.06-1.06H71.76Z",
    transform: "translate(-29.89 -70.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M71.71,124.22H45.94a1.5,1.5,0,0,1-1.5-1.5V97a1.5,1.5,0,0,1,1.5-1.5H71.71a1.5,1.5,0,0,1,1.5,1.5v25.77A1.5,1.5,0,0,1,71.71,124.22Zm-24.27-3H70.21V98.46H47.44Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M51.43,118.24a1,1,0,0,1-.71-1.71l14.8-14.8a1,1,0,0,1,1.41,1.41l-14.8,14.8A1,1,0,0,1,51.43,118.24Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M66.23,118.24a1,1,0,0,1-.71-.29l-14.8-14.8a1,1,0,0,1,1.41-1.41l14.8,14.8a1,1,0,0,1-.71,1.71Z",
    transform: "translate(-29.89 -70.86)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "control_panel",
    "data-name": "control panel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colors-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M122.68,74.26V79a1.9,1.9,0,0,1-1.9,1.89H79.28A1.9,1.9,0,0,1,77.38,79V74.26a1.9,1.9,0,0,1,1.9-1.89h41.5A1.9,1.9,0,0,1,122.68,74.26Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 59.36,
    y: 30.31,
    width: 21.56,
    height: 21.55,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M119.34,89.35v58.28H80.72V80.89h38.62Zm-8.53,32.37V102.17a1,1,0,0,0-1-1H90.25a1,1,0,0,0-1,1v19.55a1,1,0,0,0,1,1h19.56A1,1,0,0,0,110.81,121.72Z",
    transform: "translate(-29.89 -70.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "shadows-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "68.06 30.66 59.36 39.36 59.44 51.95 80.18 31.2 68.06 30.66"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 50.83,
    y: 10.03,
    width: 38.62,
    height: 4.73
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M122.68,72.37H77.38v3.2h6.05a.93.93,0,0,1,.93.93h0v4.39h8.88V76.5a.93.93,0,0,1,.93-.93h28.52Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M80.72,138.49h24.76A10.5,10.5,0,0,0,116,128h0V80.89h3.35v66.74H80.72Z",
    transform: "translate(-29.89 -70.86)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "lines-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.33,149.13H80.72a1.5,1.5,0,0,1-1.5-1.5V80.89a1.5,1.5,0,0,1,1.5-1.5h38.61a1.5,1.5,0,0,1,1.5,1.5v66.74A1.5,1.5,0,0,1,119.33,149.13Zm-37.11-3h35.61V82.39H82.22Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.78,82.39H79.27a3.4,3.4,0,0,1-3.4-3.4h0V74.26a3.4,3.4,0,0,1,3.4-3.4h41.51a3.4,3.4,0,0,1,3.4,3.4h0V79A3.4,3.4,0,0,1,120.78,82.39ZM79.27,73.87a.4.4,0,0,0-.4.4h0V79a.4.4,0,0,0,.4.4h41.51a.4.4,0,0,0,.4-.4h0V74.26a.4.4,0,0,0-.4-.4H79.27Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M109.81,124.22H90.25a2.5,2.5,0,0,1-2.5-2.5V102.17a2.5,2.5,0,0,1,2.5-2.5h19.56a2.5,2.5,0,0,1,2.5,2.5v19.56A2.5,2.5,0,0,1,109.81,124.22Zm-19.06-3h18.56V102.67H90.75Zm19.06-18.56Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M110,132.77a2,2,0,0,1,0-4h0a2,2,0,0,1,0,4Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M100,132.77a2,2,0,0,1,0-4h0a2,2,0,0,1,0,4Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M90.06,132.77a2,2,0,0,1,0-4h0a2,2,0,0,1,0,4Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.33,90.35H96.72a1,1,0,0,1,0-2h22.62a1,1,0,0,1,0,2Z",
    transform: "translate(-29.89 -70.86)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.81,90.35H80.72a1,1,0,0,1,0-2H91.81a1,1,0,0,1,0,2Z",
    transform: "translate(-29.89 -70.86)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/ai.37d58a2c.svg";
export { ForwardRef as ReactComponent };